var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.616 22.0005C9.15533 22.0005 8.771 21.8465 8.463 21.5385C8.155 21.2305 8.00067 20.8458 8 20.3845V8.00047H7V7.00047H11V6.23047H17V7.00047H21V8.00047H20V20.3855C20 20.8455 19.846 21.2298 19.538 21.5385C19.23 21.8471 18.8453 22.0011 18.384 22.0005H9.616ZM11.808 19.0005H12.808V10.0005H11.808V19.0005ZM15.192 19.0005H16.192V10.0005H15.192V19.0005Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.d404f6c68b63aba4010e7126e7195e97.svg";
export { ForwardRef as ReactComponent };